import template from './index.html'

function init (params) {
  this.text = 'i am demo'
}
export default {
  name: 'demo',
  init,
  template
}



// WEBPACK FOOTER //
// ./src/components/demo/index.js